"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultipleResolvedValueMetadataInjectOptions = isMultipleResolvedValueMetadataInjectOptions;
function isMultipleResolvedValueMetadataInjectOptions(options) {
    return (options
        .isMultiple === true);
}
//# sourceMappingURL=isMultipleResolvedValueMetadataInjectOptions.js.map